/**
 * Test IDs for QA automation.
 */
export const testIds = {
  loadedQuantityModalQuantity: "loaded-quantity-modal-quantity",
  loadedQuantityModalNetQuantity: "loaded-quantity-modal-net-quantity",
  loadedQuantityModalCancel: "loaded-quantity-modal-cancel",
  loadedQuantityModalSave: "loaded-quantity-modal-save",
} as const;
